import { useMemo } from "react"
import {
  Building02,
  Button,
  HeadingSmall,
  MessageCard,
  ParagraphMedium,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"
import { useLocalStorage } from "usehooks-ts"

import claimSwaImage from "#/assets/claim-swag.png"
import {
  selectActiveDeposits,
  selectMats,
  selectUserHasLoan,
  selectWalletBalances,
  useDappSelector,
} from "#/redux-state"
import { LOCAL_STORAGE_CLAIM_STUFF_DISMISSED, routes } from "#/shared/constants"
import { useMobileScreen } from "#/shared/hooks"
import { bigIntToCommaSeparatedFloat } from "#/shared/utils"

export default function HomepageMainSectionClaim() {
  const activeDeposits = useDappSelector(selectActiveDeposits)
  const hasLoan = useDappSelector(selectUserHasLoan)
  const { totalMats } = useDappSelector(selectMats)
  const { MUSD } = useDappSelector(selectWalletBalances)

  const [isSectionDismissed, setIsSectionDismissed] = useLocalStorage<boolean>(
    LOCAL_STORAGE_CLAIM_STUFF_DISMISSED,
    false,
  )

  const isMobileScreen = useMobileScreen()
  const [, theme] = useStyletron()

  const showSection = useMemo(
    () => activeDeposits.length > 0 && hasLoan && totalMats > 0,
    [activeDeposits.length, hasLoan, totalMats],
  )

  if (!showSection || isSectionDismissed || isMobileScreen) return null

  return (
    <MessageCard
      onDismiss={() => setIsSectionDismissed(true)}
      onClick={() => {}}
      buttonLabel="Visit market"
      heading={<HeadingSmall>Claim cool stuff from the market</HeadingSmall>}
      paragraph={
        <ParagraphMedium marginBottom={theme.sizing.scale800}>
          With{" "}
          {bigIntToCommaSeparatedFloat(
            MUSD.balance,
            Number(MUSD.decimals),
            Number(MUSD.decimals),
          )}{" "}
          testnet MUSD available to spend, why not collect some swag?
        </ParagraphMedium>
      }
      image={{
        ariaLabel: "Claim Swag",
        backgroundPosition: "left",
        layout: "trailing",
        src: claimSwaImage,
      }}
      overrides={{
        Root: {
          style: () => ({ backgroundColor: theme.colors.backgroundTertiary }),
        },
        ContentContainer: {
          style: () => ({
            padding: `${theme.sizing.scale900} ${theme.sizing.scale900} 28px ${theme.sizing.scale900}`,
          }),
        },
        Image: { style: () => ({ minWidth: "352px" }) },
        Button: {
          component: () => (
            <Button
              data-attr="card-visit_market_cta"
              $as={Link}
              href={routes.STORE}
              size="small"
              startEnhancer={<Building02 color="white" size={16} />}
            >
              Visit market
            </Button>
          ),
        },
      }}
    />
  )
}
